import { atomWithStorage } from "jotai/utils"
import { areaBasedStorage, getAreaBasedJsonStorage } from "@/lib/utils.client"

const PRIVACY_CONSENT_KEY = "privacy-consent"

// 获取隐私协议同意状态的工具函数，用于在非React组件中使用
export const getStoredPrivacyConsent = (): boolean => {
	if (typeof window === "undefined") {
		return false
	}
	try {
		const result = getAreaBasedJsonStorage<boolean>(PRIVACY_CONSENT_KEY)
		return result ?? false
	} catch (error) {
		console.error("Error getting stored privacy consent:", error)
		return false
	}
}

// 创建隐私协议同意状态的持久化atom，保存到localStorage
export const privacyConsentAtom = atomWithStorage<boolean>(
	PRIVACY_CONSENT_KEY,
	getStoredPrivacyConsent(),
	areaBasedStorage,
)
